/**
 * MODULE: _shared/frontend-shell/src/components/brain/BrainInsightPreferenceHint.tsx
 * PURPOSE: Violet preference subline with optional link to Settings learned-preferences panel.
 * DEPENDENCIES: react-router-dom, brainInsightLinks
 * PUBLIC_API: BrainInsightPreferenceHint
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 48 / 100 lines
 * RECENT: 2026-05-25 [2.2.1207] — self-learning UX loop: insight hint → Settings manage.
 */

import { Link } from 'react-router-dom';
import { brainLearnedPreferencesSettingsPath } from '@shared/lib/frontend/utils/brainInsightLinks';

type Props = {
  text: string;
  testId?: string;
  showManageLink?: boolean;
};

export function BrainInsightPreferenceHint({
  text,
  testId,
  showManageLink = true,
}: Props) {
  return (
    <p
      className="mt-1 text-[11px] text-violet-700 dark:text-violet-300"
      data-testid={testId}
    >
      {text}
      {showManageLink ? (
        <>
          {' '}
          <Link
            to={brainLearnedPreferencesSettingsPath()}
            className="font-medium underline decoration-violet-400/60 underline-offset-2 hover:text-violet-900 dark:hover:text-violet-100"
            data-testid={testId ? `${testId}-manage-link` : 'brain-preference-manage-link'}
            onClick={(e) => e.stopPropagation()}
          >
            Manage
          </Link>
        </>
      ) : null}
    </p>
  );
}
